export function environment() {
    // For Acadia & Glacier
    if (process.env.WEBAPP_ENV !== undefined) {
        return process.env.WEBAPP_ENV;
    }
    // For Yellowstone
    if (process.env.REACT_APP_CONFIG !== undefined) {
        const envMap = {
            development: "UAT",
            uat: "UAT",
            production: "PROD",
        };
        return envMap[process.env.REACT_APP_CONFIG];
    }
    throw new Error("No environment found");
}
//# sourceMappingURL=environment.js.map